<template lang="pug" src="./template.pug"></template>

<script>
import _ from 'lodash'

import { useSetupStore } from '@/stores'
import quillConfig from '@/quill/config'

export default {
    name: 'ProductTransferInputField',
    props: {
        config: {
            type: Object,
            required: true,
        },
        form: {
            type: Object,
            required: true,
        },
        hideLabel: {
            type: Boolean,
            default: false
        },
        // el-input-number `input-size` of numberfields; the template reads it
        size: {
            type: String,
            default: undefined
        },
        // a message from the server, shown under the field
        error: {
            type: String,
            default: undefined
        }
    },
    data() {
        quillConfig.modules.link.pages = this.getPageOptions
        return {
            quillConfig,
        }
    },
    computed: {
        setupStore() {
            return useSetupStore();
        },
        activeCms() {
            return this.setupStore.activeCms;
        },
        selectOptions() {
            const options = _.get(this.config, 'options') || [];

            return options.filter(option => this.checkConditions(option));
        },
        visible() {
            return this.checkConditions(this.config);
        },
        label() {
            let label
            switch (this.config.type) {
                case 'switch':
                case 'checkbox':
                case 'boolean-button':
                    label = null
                    break;

                default:
                    if (! this.hideLabel) label = this.config.name
            }

            return label
        },
        value: {
            get() {
                return _.get(this.form, this.config.key)
            },
            set(value) {
                switch (this.config.type) {
                    case 'radio':
                    case 'switch':
                    case 'checkbox':
                    case 'boolean-button':
                    case 'boolean-button-group':
                        if (['true', '1', 'yes', true].includes(value)) value = true;
                        else value = false;
                        break;
                }

                this.$set(this.form, this.config.key, value);
                this.$emit('change', { field: this.config.field, key: this.config.key, value })
            }
        },
        numberValue: {
            get() {
                return parseFloat(this.value)
            },
            set(value) {
                this.value = value
            }
        },
    },
    methods: {
        checkConditions(setting) {
            let valid = true;

            // "settings" is the form itself - other templates rely on that, so it stays.
            // "cms" exposes the active shop for conditions that depend on its configuration
            // rather than on what the operator picked in this form.
            // eslint-disable-next-line no-unused-vars
            const settings = this.form;
            // eslint-disable-next-line no-unused-vars
            const cms = this.activeCms;
            try {
                const conditions = setting.conditions;
                if (conditions && conditions.length) {
                    conditions.forEach(o => {
                        if (valid === false) return;

                        const { type, condition } = o;
                        switch (type) {
                            case 'eval':
                                valid = eval(condition);
                                break;

                            default:
                                valid = false;
                        }
                    });
                }
            } catch (error) {
                // eslint-disable-next-line
                console.error(error);
                valid = false;
            }

            return valid;
        },
        pruneHiddenOptions() {
            if (this.config.type !== 'multi-select') return;

            const allowed = this.selectOptions.map(option => option.key);
            const current = _.get(this.form, this.config.key) || [];
            const pruned = current.filter(key => allowed.includes(key));

            if (pruned.length !== current.length) this.value = pruned;
        },
        getBooleanButtonGroupOptionType(value) {
            const key = this.config.key

            if (['true', '1', 'yes', true].includes(value)) value = true;
            else value = false;

            return this.form[key] === value ? 'primary' : 'default';
        },
    },
    watch: {
        // the parent seeds the defaults without knowing about conditions, and it does so in
        // its own mounted hook - which runs after this component is mounted. so react to the
        // value instead of pruning once on mount, or the seeding would never be corrected.
        value: {
            immediate: true,
            handler() {
                this.pruneHiddenOptions();
            }
        }
    }
}
</script>
